import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import ModalPortal from '../../../components/modal-portal';

import messages from './messages';
import style from './style.module.less';

const ConfirmDisableSmartRouting = ({ handleContinueDisablingSmartRouting, onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style['disable-smart-routing-modal']}>
        <ModalHeader>
          <FormattedMessage {...messages.confirmationTitleWhenDisablingSmartRouting} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <p>
            <FormattedMessage {...messages.confirmationTextWhenDisablingSmartRouting} />
          </p>
          <p>
            <FormattedMessage {...messages.confirmationModalCancelChangesForSmartRouting} />
          </p>
          <p>
            <FormattedMessage {...messages.confirmationContinueWhenDisablingSmartRouting} />
          </p>
        </ModalBody>
        <ModalFooter className={style['modal-footer']}>
          <ModalFooterCancelButton />
          <Button onClick={handleContinueDisablingSmartRouting} theme='primary'>
            <FormattedMessage {...messages.continue} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

ConfirmDisableSmartRouting.propTypes = {
  handleContinueDisablingSmartRouting: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmDisableSmartRouting;
